(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Mattress = function () {
  function Mattress(aMenus) {
    _classCallCheck(this, Mattress);

    this.menus = aMenus;
  }

  _createClass(Mattress, [{
    key: "printMenu",
    value: function printMenu() {
      this.menus.print();
    }
  }]);

  return Mattress;
}();

exports.default = Mattress;

},{}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _MenuComponent2 = require('./MenuComponent');

var _MenuComponent3 = _interopRequireDefault(_MenuComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Menu = function (_MenuComponent) {
  _inherits(Menu, _MenuComponent);

  function Menu(name, description) {
    _classCallCheck(this, Menu);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Menu).call(this));

    _this.menuComponents = [];
    _this.name = name;
    _this.description = description;
    _this.createIterator = function () {
      throw new Error('This method must be overwritten!');
    };
    return _this;
  }

  _createClass(Menu, [{
    key: 'add',
    value: function add(menuComponent) {
      this.menuComponents.push(menuComponent);
    }
  }, {
    key: 'remove',
    value: function remove(menuComponent) {
      this.menuComponents = this.menuComponents.filter(function (component) {
        return component !== component;
      });
    }
  }, {
    key: 'getChild',
    value: function getChild(index) {
      return this.menuComponents[index];
    }
  }, {
    key: 'getName',
    value: function getName() {
      return this.name;
    }
  }, {
    key: 'getDescription',
    value: function getDescription() {
      return this.description;
    }
  }, {
    key: 'print',
    value: function print() {
      console.log(this.getName() + ": " + this.getDescription());
      console.log("--------------------------------------------");
      this.menuComponents.forEach(function (component) {
        component.print();
      });
    }
  }]);

  return Menu;
}(_MenuComponent3.default);

exports.default = Menu;

},{"./MenuComponent":3}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MenuComponent = function () {
  function MenuComponent() {
    var name = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
    var description = arguments.length <= 1 || arguments[1] === undefined ? '' : arguments[1];
    var isVegetarian = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
    var price = arguments.length <= 3 || arguments[3] === undefined ? 0 : arguments[3];

    _classCallCheck(this, MenuComponent);

    this.name = name;
    this.description = description;
    this._isVegetarian = isVegetarian;
    this.price = price;
  }

  _createClass(MenuComponent, [{
    key: 'getName',
    value: function getName() {
      return this.name;
    }
  }, {
    key: 'getDescription',
    value: function getDescription() {
      return this.description;
    }
  }, {
    key: 'getPrice',
    value: function getPrice() {
      return this.price;
    }
  }, {
    key: 'isVegetarian',
    value: function isVegetarian() {
      return this._isVegetarian;
    }
  }, {
    key: 'print',
    value: function print() {
      shouldBeOverwritten();
    }
  }, {
    key: 'add',
    value: function add() {
      shouldBeOverwritten();
    }
  }, {
    key: 'remove',
    value: function remove() {
      shouldBeOverwritten();
    }
  }, {
    key: 'getChild',
    value: function getChild() {
      shouldBeOverwritten();
    }
  }]);

  return MenuComponent;
}();

exports.default = MenuComponent;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _MenuComponent2 = require("./MenuComponent");

var _MenuComponent3 = _interopRequireDefault(_MenuComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MenuItem = function (_MenuComponent) {
  _inherits(MenuItem, _MenuComponent);

  function MenuItem() {
    _classCallCheck(this, MenuItem);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(MenuItem).apply(this, arguments));
  }

  _createClass(MenuItem, [{
    key: "print",
    value: function print() {
      console.log(this.getName() + ": " + this.getDescription() + ", " + this.getPrice() + "euros");
    }
  }]);

  return MenuItem;
}(_MenuComponent3.default);

exports.default = MenuItem;

},{"./MenuComponent":3}],5:[function(require,module,exports){
'use strict';

var _Menu = require('./Menu');

var _Menu2 = _interopRequireDefault(_Menu);

var _MenuItem = require('./MenuItem');

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _Mattress = require('./Mattress');

var _Mattress2 = _interopRequireDefault(_Mattress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var oPanCakeHouseMenu = new _Menu2.default("Pancake House Menu", "Breakfast");
var oLunchMenu = new _Menu2.default("Lunch Menu", "Lunch");
var oCoffeeMenu = new _Menu2.default("Cafe Menu", "Dinner");
var oAllMenus = new _Menu2.default("ALL MENUS", "All menus combined");

oAllMenus.add(oPanCakeHouseMenu);
oAllMenus.add(oLunchMenu);

oLunchMenu.add(new _MenuItem2.default("Pasta", "Spaghetti with Marinara Sauce, and a slice of sourdough bread", true, 3.89));
oLunchMenu.add(oCoffeeMenu);

oCoffeeMenu.add(new _MenuItem2.default("Express", "Coffee from machine", false, 0.99));

var oMattress = new _Mattress2.default(oAllMenus);
console.log("---------------------------------------------");
oMattress.printMenu();
console.log("---------------------------------------------");

},{"./Mattress":1,"./Menu":2,"./MenuItem":4}]},{},[5])

